import { useTheme } from "@mui/material/styles";
import { ComputedDatum } from "@nivo/pie";
import { ReactComponent as CircleIcon } from "components/Icons/circle.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React from "react";
import { useStyles } from "./MembersByTiers.styles";

interface CircleGraphItem {
  id: string;
  label: string;
  value: number;
  color: string;
}

export const MembersByTiersTooltip: React.FC<{
  datum: ComputedDatum<CircleGraphItem>;
}> = ({ datum }) => {
  const theme: OLTheme = useTheme();
  const classes = useStyles();

  return (
    <div className={classes.tooltip}>
      <div className={classes.alignCenter}>
        <CircleIcon
          style={{
            color: datum.color,
            fontSize: 12,
            height: 12,
            marginRight: theme.spacing(2),
            width: 12,
          }}
        />
        {`${datum.label}:`}
        <span className={classes.boldText}>{datum.value}</span>
      </div>
    </div>
  );
};
